import React from 'react'
import { View, Text, TouchableOpacity, StyleSheet, StyleProp, ViewStyle } from 'react-native'
import { corporateColor, textColor } from '../../theme/colors'
import { DOBRA } from '../../theme/fonts'

interface RadioButtonProps {
  options: string[]
  selected: string
  onSelect: (value: string) => void
  disabledOptions?: string[]
  customStyes?: {
    container?: StyleProp<ViewStyle>
  }
}

export const RadioButton = ({
  options,
  selected,
  onSelect,
  disabledOptions = [],
  customStyes,
}: RadioButtonProps) => {
  const isDisabled = (option: string) => disabledOptions.includes(option)

  return (
    <View style={[styles.radioGroup, customStyes?.container]}>
      {options.map((option) => (
        <TouchableOpacity
          key={option}
          style={styles.radioButtonContainer}
          onPress={() => !isDisabled(option) && onSelect(option)}
          disabled={isDisabled(option)}
        >
          <View style={[styles.radioCircle, isDisabled(option) && styles.disabledRadioCircle]}>
            {selected === option && (
              <View
                style={[styles.selectedCircle, isDisabled(option) && styles.disabledSelectedCircle]}
              />
            )}
          </View>
          <Text style={[styles.optionText, isDisabled(option) && styles.disabledOptionText]}>
            {option}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  radioGroup: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  radioButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  radioCircle: {
    height: 24,
    width: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: corporateColor,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  selectedCircle: {
    height: 13,
    width: 13,
    borderRadius: 6,
    backgroundColor: corporateColor,
  },
  optionText: {
    fontSize: 16,
    color: textColor,
    fontFamily: DOBRA,
  },
  selectedText: {
    marginTop: 20,
    fontSize: 18,
    color: '#555',
    fontFamily: DOBRA,
  },
  disabledRadioCircle: {
    borderColor: '#cccccc',
  },
  disabledSelectedCircle: {
    backgroundColor: '#cccccc',
  },
  disabledOptionText: {
    color: '#cccccc',
  },
})
